import { DrawerState } from './DrawerState';

export const drawerInitialState: DrawerState = {
  drawer: {
    type: undefined,
    id: undefined,
    open: false,
  },
};
